module.exports = [
	{
		"id": "housing-status-select",
		"name": "Please select...",
		"value": ""
	},
	{
		"id": "housing-status-own",
		"name": "Own home",
		"value": "O"
	},
	{
		"id": "housing-status-rent",
		"name": "Renting",
		"value": "R"
	},
	{
		"id": "housing-status-board",
		"name": "Board",
		"value": "B"
	},
	{
		"id": "housing-status-at-home",
		"name": "Living at Home",
		"value": "L"
	},
	{
		"id": "housing-status-with-relative",
		"name": "Living with relative",
		"value": "W"
	},
	{
		"id": "housing-status-not-saying",
		"name": "Not willing to supply",
		"value": "Z"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/checkout/CreditAssessmentStep2/HousingStatuses.json
 ** module id = 1372
 ** module chunks = 0
 **/